@if (!hidden()) {
  <div
    class="checkbox"
    [class.active]="checked()"
    [class.disabled]="disabled()"
    [class.invalid]="isInvalid()"
    [tabindex]="disabled() ? -1 : 0"
    (focusout)="touch.emit()"
    #checkboxElement
  >
    <onyx-icon
      class="checkbox-icon"
      [name]="indeterminate() ? 'indeterminate-outlined' : 'check-outlined'"
      [size]="16"
    ></onyx-icon>
  </div>

  @let control = formField() ?? formControl();
  @if (label(); as label) {
    <div class="label">
      <onyx-input-label
        variant="title"
        [label]="label"
        [required]="!!control && required() && showRequired()"
        [disabled]="disabled()"
      ></onyx-input-label>

      @if (count(); as count) {
        <span class="f-muted" [class.disabled]="disabled()">
          {{ count | number: '1.0-0' }}
        </span>
      }
    </div>
  }

  @if (hint(); as hint) {
    <onyx-icon
      class="f-muted"
      [class.disabled]="disabled()"
      name="tooltip-filled"
      [size]="12"
      [onyxTooltip]="hint"
      onyxTooltipTextAlign="left"
    ></onyx-icon>
  }

  @if (control && showErrors()) {
    <onyx-error [errors]="[control]"></onyx-error>
  }
}
